import React, { useState, useEffect } from 'react';
import api from '../api';

export default function ResetPassword({ goToLogin }) {
  const [token, setToken] = useState('');
  const [form, setForm] = useState({ password: '', confirm: '' });
  const [status, setStatus] = useState('form'); // form | success | error
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const t = params.get('token');
    if (t) setToken(t);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.password !== form.confirm) return setError('Passwords do not match');
    if (form.password.length < 8) return setError('Password must be at least 8 characters');
    setLoading(true); setError('');
    try {
      await api.post('/auth/reset-password', { token, password: form.password });
      setStatus('success');
    } catch (err) {
      setError(err.response?.data?.error || 'Reset failed. The link may have expired.');
      setStatus('error');
    }
    setLoading(false);
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'transparent' }}>
      <div style={{ background: 'var(--glass-2)', backdropFilter: 'var(--blur)', WebkitBackdropFilter: 'var(--blur)', border: '1px solid var(--glass-border)', borderRadius: 16, padding: '40px 36px', width: 380, boxShadow: '0 20px 60px rgba(0,0,0,.3)' }}>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <div style={{ fontSize: '1.8rem', fontWeight: 800, color: 'var(--text)' }}>HR<span style={{ color: '#4f46e5' }}>Track</span></div>
          <div style={{ color: 'var(--muted)', marginTop: 6, fontSize: '0.9rem' }}>Choose a new password</div>
        </div>

        {status === 'success' && (
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '2.5rem', marginBottom: 16 }}>✅</div>
            <h3 style={{ color: 'var(--text)', marginBottom: 8 }}>Password updated!</h3>
            <p style={{ color: 'var(--muted)', marginBottom: 24 }}>You can now sign in with your new password.</p>
            <button onClick={goToLogin} className="btn btn-primary" style={{ width: '100%', justifyContent: 'center', padding: '10px' }}>Sign In</button>
          </div>
        )}

        {status !== 'success' && (
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>New Password</label>
              <input autoFocus type="password" value={form.password} onChange={e => setForm(f => ({ ...f, password: e.target.value }))} placeholder="Min. 8 characters" required />
            </div>
            <div className="form-group">
              <label>Confirm Password</label>
              <input type="password" value={form.confirm} onChange={e => setForm(f => ({ ...f, confirm: e.target.value }))} placeholder="••••••••" required />
            </div>
            {error && <div style={{ background: '#fee2e2', color: '#991b1b', padding: '8px 12px', borderRadius: 8, marginBottom: 14, fontSize: '0.875rem' }}>{error}</div>}
            <button type="submit" className="btn btn-primary" disabled={loading || !token} style={{ width: '100%', justifyContent: 'center', padding: '10px' }}>
              {loading ? 'Updating…' : 'Reset Password'}
            </button>
            {!token && <p style={{ color: '#f59e0b', fontSize: '0.8rem', marginTop: 8 }}>No reset token found. Please use the link from your email.</p>}
            <p style={{ textAlign: 'center', marginTop: 16, fontSize: '0.875rem', color: 'var(--muted)' }}>
              <button onClick={goToLogin} style={{ background: 'none', border: 'none', color: '#4f46e5', cursor: 'pointer', fontWeight: 600 }}>← Back to Sign In</button>
            </p>
          </form>
        )}
      </div>
    </div>
  );
}
